import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import ReactGA from 'react-ga4';
import Auth from '../services/auth';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'
import { InputLabel, Toolbar, Tooltip } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { red } from '@material-ui/core/colors';
import SettingsDataAccess from '../services/settingsDataAccess';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import PubSub from 'pubsub-js';
import IntegrationAutosuggest from './IntegrationAutosuggest';
import ProcedureDataAccess from '../services/procedureDataAccess';
import InputAdornment from '@material-ui/core/InputAdornment';
import Chip from '@material-ui/core/Chip';

const dataAccess = new SettingsDataAccess();
const proceduredataAccess = new ProcedureDataAccess();
const auth = new Auth();

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
})

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing(2),
    }),
    Cost: {
        background: red,
    },
    card: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        marginBottom: 16,
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

//<Grid
//    container
//    spacing={0}
//    direction="column"
//    alignItems="center"
//    justify="center"
//    style={{ minHeight: '100vh' }}
//>
export class Settings extends Component {
    displayName = Settings.name
    constructor(props) {
        super(props);

        this.state = {
            accountProcedures: [],
            selectedProcedures: [],
            filteredProcedures: [],
            updatedProcedures: [],
            data: {
                Id: 0,
                Account: "",
                SettingName: "",
                SettingValue: "",


            },
            user: {
                Id: 0,
                Account: auth.getActiveAccount(),
                AccountCreatedBy: "",
                Accounts: [],
                Active: true,
                SSOIdentity: "",
                Company: "",
                Dictators: [],
                EMail: "",
                FirstName: "",
                IsDeleted: false,
                IsDocumentWatermarked: false,
                IsVerified: false,
                LastName: "",
                Location: "",
                Maint: "",
                ModifyingUser: "",
                Password: "",
                Phone: "",
                Roles: [],
                SecArchive: false,
                SecCoding: 0,
                SecMarkRead: false,
                SecSave: false,
                SecSign: false,
                UserId: ""
            },
            value: "",
            statusFilters: [],
            isLoading: true,
            openSnack: false,
            snackMessage: "",
            displayFilter: false,
            isIndividualFaxingEnabled: false,
            faxSettingId: 0,
            isFaxingLoading: true,
        };
        let self = this;
    }

    generation = 0;
    mounted = true;
    costIntent = null;
    faxIntent = null;
    costPending = false;
    faxPending = false;
    newChangeId = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0; return (c === 'x' ? r : ((r & 3) | 8)).toString(16);
    });
    current = generation => this.mounted && generation === this.generation;
    accountChanged = () => {
        this.generation++;
        this.costIntent = null; this.faxIntent = null;
        this.setState({ costConflict: false, faxConflict: false, costDirty: false, costError: '', faxError: '',
            costSaving: false, faxSaving: false, data: { Id: 0, SettingValue: '' }, updatedProcedures: [] }, () => {
            this.loadMonetizationData(); this.loadIndividualFaxingData(); this.setAccountsProcedures();
        });
    };
    componentWillUnmount() {
        this.mounted = false; this.generation++;
        if (this.token) PubSub.unsubscribe(this.token);
    }
    onClassicView = () => {
        const auth = new Auth();
        ReactGA.event({
            action: 'Classic Portal',
            category: `${auth.getGaUser()}`
        });
    }
    handleDelete = item => () => {

        var procedure = this.state.selectedProcedures;
        var accountProcedures = this.state.accountProcedures;
        var updatedProcedures = this.state.updatedProcedures;
        var index = procedure.findIndex(p => p.ProcedureId === item.ProcedureId);

        if (index > -1) {
            procedure.splice(index, 1);

            var fullProcedure = accountProcedures.find(procedure => procedure.ProcedureId === item.ProcedureId);
            var updateIndex = updatedProcedures.findIndex(procedure => procedure.ProcedureId === item.ProcedureId);
            if (updateIndex > -1) {
                updatedProcedures[updateIndex].IsFiltered = false;
                updatedProcedures.splice(updateIndex, 1, updatedProcedures[updateIndex]);
                accountProcedures.push(updatedProcedures[updateIndex]);
            }
            else {
                fullProcedure.IsFiltered = false;
                updatedProcedures.push(fullProcedure);
                accountProcedures.push(fullProcedure);
            }
            this.setState({ selectedProcedures: procedure, accountProcedures: accountProcedures, updatedProcedures: updatedProcedures });
        }

    }
    onSuggestionSelected = (selectedItem) => {


        //var self = this.state
        var procedure = this.state.selectedProcedures;
        var filteredProcedures = this.state.filteredProcedures;
        var accountProcedures = this.state.accountProcedures;
        var updatedProcedures = this.state.updatedProcedures;

        var indexProc = procedure.findIndex(p => p.ProcedureId === selectedItem.ProcedureId);
        if (indexProc === -1) {
            procedure.push(selectedItem);
            filteredProcedures.push(selectedItem);
        }
        selectedItem.IsFiltered = true;
        var updateIndex = updatedProcedures.findIndex(procedure => procedure.ProcedureId === selectedItem.ProcedureId);
        if (updateIndex > -1) {
            updatedProcedures[updateIndex].IsFiltered = true;
            updatedProcedures.splice(updateIndex, 1, updatedProcedures[updateIndex]);
        }
        else {
            updatedProcedures.push(selectedItem);
        }
        var index = accountProcedures.findIndex(procedure => procedure.ProcedureId === selectedItem.ProcedureId);
        this.setState({ selectedProcedures: procedure, accountProcedures: accountProcedures, updatedProcedures: updatedProcedures });
    }

    handleSnackClose = () => {
        this.setState({
            openSnack: false,
        });
    };
    loadMonetizationData = () => {
        if (this.costPending) return;
        if (this.state.costDirty && !window.confirm('Discard the unsaved reimbursement edit and reload?')) return;
        const generation = this.generation;
        this.setState({ isLoading: true, costError: '' });
        return dataAccess.getAccountSettings(auth.getActiveAccount()).then(response => {
            if (!this.current(generation)) return;
            this.costIntent = null;
            this.setState({ data: response.data || { Id: 0, SettingValue: '', SettingsVersion: null },
                costDirty: false, costConflict: false, isLoading: false });
        }).catch(() => {
            if (this.current(generation)) this.setState({ isLoading: false, costConflict: true, costError: 'Unable to load reimbursement. Reload before saving.' });
        });
    }
    loadIndividualFaxingData = () => {
        if (this.faxPending) return;
        const generation = this.generation;
        this.setState({ isFaxingLoading: true, faxError: '' });
        return dataAccess.getAccountSettingsBySettingsName('FaxByAddress', auth.getActiveAccount()).then(response => {
            if (!this.current(generation)) return;
            const setting = response.data;
            const value = setting && setting.SettingValue ? String(setting.SettingValue).trim().toLowerCase() : '';
            this.faxIntent = null;
            this.setState({ isIndividualFaxingEnabled: value === 'true' || value === '1', faxSettingId: setting ? setting.Id : 0,
                faxVersion: setting ? setting.SettingsVersion : null, faxConflict: false, isFaxingLoading: false });
        }).catch(() => {
            if (this.current(generation)) this.setState({ isFaxingLoading: false, faxConflict: true, faxError: 'Unable to load fax settings. Reload before saving.' });
        });
    }
    handleFaxingToggle = () => {
        if (this.faxPending || this.state.faxConflict || this.state.isFaxingLoading) return;
        const generation = this.generation;
        const value = !this.state.isIndividualFaxingEnabled;
        if (!this.faxIntent || this.faxIntent.value !== value) this.faxIntent = { value, id: this.newChangeId() };
        this.faxPending = true;
        this.setState({ faxSaving: true, faxError: '' });
        return dataAccess.saveIndividualFaxingSettings(this.state.faxSettingId, value, this.state.faxVersion || null, this.faxIntent.id, auth.getActiveAccount())
            .then(response => {
                if (!this.current(generation)) return;
                const saved = response.data || {};
                this.faxIntent = null;
                this.setState({ isIndividualFaxingEnabled: value, faxVersion: saved.SettingsVersion,
                    faxConflict: !saved.SettingsVersion, faxError: saved.SettingsVersion ? '' : 'Saved. Reload before making another change.',
                    openSnack: true, snackMessage: 'Fax delivery method saved.' });
            }).catch(error => {
                if (!this.current(generation)) return;
                const conflict = error.response && error.response.status === 409;
                this.setState({ faxConflict: !!conflict, faxError: conflict ? 'Fax settings changed. Reload and review before changing again.' :
                    'Save was not confirmed. Retry the same toggle or reload to review the saved value.' });
            }).then(() => {
                this.faxPending = false;
                if (this.current(generation)) this.setState({ faxSaving: false });
                else if (this.mounted) this.loadIndividualFaxingData();
            });
    }
    componentWillMount() {
        this.loadMonetizationData();
        this.setAccountsProcedures();
        this.loadIndividualFaxingData();
        this.token = PubSub.subscribe('AccountChanged', this.accountChanged);
    }
    onChangeFunction(component, value) {
        this.setValue({ defaultValue: value });
    }
    setAccountsProcedures = () => {

        var self = this;
        self.setState({ displayFilter: false });
        proceduredataAccess.getAccountProcedures()
            .then(function (response) {

                var procedures = response.data.map((procedure, i) => {
                    const result = Object.assign({}, procedure,
                        {
                            Name: (procedure.Code === 'null' || procedure.Code === null) ? `${procedure.Description}` : `${procedure.Code} - ${procedure.Description}`
                        });
                    return result;
                });

                self.setState({ accountProcedures: procedures, displayFilter: true, selectedProcedures: procedures.filter(p => p.IsFiltered) });
            })
            .catch(error => {

            })

    }
    setCostPerCase() {
        if (this.costPending || this.state.costConflict || this.state.isLoading) return;
        const raw = this.state.data.SettingValue;
        if (raw === '' || !Number.isFinite(Number(raw))) {
            this.setState({ costError: 'Enter a valid reimbursement amount.' }); return;
        }
        const generation = this.generation;
        const value = String(Math.ceil(Number(raw)));
        if (!this.costIntent || this.costIntent.value !== value) this.costIntent = { value, id: this.newChangeId() };
        this.costPending = true;
        this.setState({ costSaving: true, costError: '' });
        return dataAccess.setAccountSettings({ Id: this.state.data.Id, Account: auth.getActiveAccount(),
            SettingValue: value, ExpectedVersion: this.state.data.SettingsVersion || null, ChangeId: this.costIntent.id })
            .then(response => {
                if (!this.current(generation)) return;
                const saved = response.data || {};
                this.costIntent = null;
                this.setState({ data: { ...this.state.data, SettingValue: saved.SettingValue === undefined ? value : saved.SettingValue,
                    SettingsVersion: saved.SettingsVersion }, costDirty: false, costConflict: !saved.SettingsVersion,
                    costError: saved.SettingsVersion ? '' : 'Saved. Reload before making another change.',
                    openSnack: true, snackMessage: 'Reimbursement saved' });
            }).catch(error => {
                if (!this.current(generation)) return;
                const conflict = error.response && error.response.status === 409;
                this.setState({ costConflict: !!conflict, costError: conflict ? 'Reimbursement changed. Your edit is preserved. Reload and review before saving.' :
                    'Save was not confirmed. Retry the unchanged amount or reload to review the saved value.' });
            }).then(() => {
                this.costPending = false;
                if (this.current(generation)) this.setState({ costSaving: false });
                else if (this.mounted) this.loadMonetizationData();
            });
    }

    setProcedureFilter = () => {
        var self = this;
        var procedures = self.state.updatedProcedures;
        for (var i = 0; i < procedures.length; i++) {

            proceduredataAccess.setProcedureFilter(procedures[i])
                .then(function () {
                    self.setState({ openSnack: true, snackMessage: 'Procedure filters saved' });
                }).catch(error => {
                });
        }
    }
    handleCostChange = event => {
        this.costIntent = null;
        this.setState({ data: { ...this.state.data, SettingValue: event.target.value }, costDirty: true, costError: '' });
    };

    render() {
        const { classes } = this.props;
        const { openSnack, snackMessage, accountProcedures, displayFilter } = this.state;

        return (
            <div style={{ paddingBottom: 250 }}>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    open={openSnack}
                    autoHideDuration={3000}
                    onClose={this.handleSnackClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{snackMessage}</span>}
                />
                <Typography variant="h5" gutterBottom>
                    Facility Settings
                </Typography>
                <br />
                <Grid container>
                    <Grid item xs={6}>
                        <Grid container spacing={4} direction="column" justify="center">

                            <Grid item>
                                <Typography variant="body1" gutterBottom>
                                    Case Reimbursement
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Card className="test">
                                    <CardContent>
                                        <TextField disabled={this.state.isLoading || this.state.costSaving} value={this.state.data.SettingValue} onChange={this.handleCostChange} helperText={this.state.IsLoading ? <CircularProgress /> : `Enter the blended average reimbursement rate per case in dollars`} label="Blended average reimbursement rate"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                            }}
                                            type="number"
                                            variant="filled" />
                                    </CardContent>
                                    {this.state.costError && <Typography color="error" role="alert">{this.state.costError}</Typography>}
                                    <Button disabled={this.state.costSaving || this.state.isLoading} onClick={this.loadMonetizationData}>Reload reimbursement</Button>
                                    <CardActions>
                                        {
                                            <Button disabled={this.state.isLoading || this.state.costSaving || this.state.costConflict || !(auth.isInRole('FacilityAdmin') || auth.isInRole('Admin'))} variant="contained" color="primary" size="small" onClick={() => this.setCostPerCase()}>Update</Button>
                                        }
                                    </CardActions>

                                </Card>
                            </Grid>
                            <Grid item>
                                <Typography variant="body1" gutterBottom>
                                    Procedure Filters
                    </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="body1" gutterBottom>
                                </Typography>

                                <Card>
                                    <CardContent>
                                        <Grid container direction="column" spacing={2}>
                                            {this.state.selectedProcedures && this.state.selectedProcedures.map((p, i) => {
                                                return (
                                                    <Tooltip title={p.Name} placement="right-start" key={i}>
                                                        <Grid key={i} item xs={2}>
                                                            <Chip
                                                                key={i}
                                                                label={p.Name.length > 100 ? `${p.Name.substring(0, 99)}...` : p.Name}
                                                                onDelete={this.handleDelete(p)}
                                                                className={classes.chip}
                                                            />
                                                        </Grid>
                                                    </Tooltip>
                                                );
                                            }, this)}

                                        </Grid>
                                        {!displayFilter && <CircularProgress />}
                                        {displayFilter && <IntegrationAutosuggest suggestions={accountProcedures} placeholder={'Exclude Procedure'} onSuggestionSelected={this.onSuggestionSelected} clearAfterSelect={true} />}
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                    </CardContent>
                                    <CardActions>
                                        {
                                            <Button disabled={!(auth.isInRole('FacilityAdmin') || auth.isInRole('Admin'))} variant="contained" color="primary" size="small" onClick={() => this.setProcedureFilter()}>Update</Button>
                                        }
                                    </CardActions>

                                </Card>
                            </Grid>

                            <Grid item>
                                <Typography variant="body1" gutterBottom>
                                    Fax Delivery Method
                                    <Typography component="span" variant="caption" color="textSecondary" style={{ marginLeft: 8, fontWeight: 400 }}>
                                        (Batch Faxing is enabled by default. Please enable Individual Faxing below to send each report as a separate fax.)
                                    </Typography>
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Card>
                                    <CardContent>
                                        {this.state.faxError && <Typography color="error" role="alert">{this.state.faxError}</Typography>}
                                        <Button disabled={this.state.faxSaving || this.state.isFaxingLoading} onClick={this.loadIndividualFaxingData}>Reload fax settings</Button>
                                        {this.state.isFaxingLoading
                                            ? <CircularProgress />
                                            : <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={this.state.isIndividualFaxingEnabled}
                                                        onChange={this.handleFaxingToggle}
                                                        value="IndividualFaxing"
                                                        disabled={this.state.faxSaving || this.state.faxConflict || !auth.isInRole('Admin')}
                                                    />
                                                }
                                                label={
                                                    <Typography>
                                                        Individual Faxing 
                                                    </Typography>
                                                }
                                            />
                                        }
                                    </CardContent>
                                </Card>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </div>
        );
    }
}
export default withStyles(styles, { withTheme: true })(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings.js